module.exports = __webpack_public_path__ + "static/media/early-bird.6059dcc6.png";